import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import socket from "../../context/socket";
import { useNavigate } from "react-router-dom";

import { MdCheck, MdResetTv } from "react-icons/md";
import { PiWarningCircleBold } from "react-icons/pi"
import { GrPowerReset } from "react-icons/gr";
import api from "../../utils/api";
const CaptchaVerification = ({
  show,
  onHide,
  onSave,
  roomId,
  panNumber,
  kycStatus,
  fatcaStatus,
  mobileNumber,
  emailAddress,
  aadhaarConfirmed,
  iAmOption,
  isRelation,
  isRelation2,
  clientEmail,
}) => {
  const [captchaText, setCaptchaText] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isCptchaImage, setCaptchaImage] = useState();
  // console.log("isCptchaImage", isCptchaImage);
  const navigate = useNavigate();

  // Initialize react-hook-form
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const getCaptcha = async () => {
    const allData = {
      _id: roomId,
      action: "newcaptcha",
    };
    try {
      const response = await api.post(
       "advisor/kyc_process",
        allData
      );
      setErrorMessage("");
      // console.log("getCaptcha", response);
      setCaptchaImage(response.data);
    } catch (error) {
      console.log("somthing wrong", error);
    }
  };

  // Function to generate random alphanumeric string
  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captcha = "";
    for (let i = 0; i < 6; i++) {
      captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(captcha);
    setCaptchaVerified(true);
    // setErrorMessage("");
    setValue("inputText", "");
  };

  const onSubmit = async (data) => {
    console.log("data.inputText", data.inputText);
    const allData = {
      _id: roomId,
      action: "verifycaptcha",
      captcha_id: isCptchaImage?.captcha_id,
      captchaText: data.inputText,
    };

    console.log("allData", allData);
    try {
      const response = await api.post(
       "advisor/kyc_process",
        allData
      );
      console.log("onSubmit kyc_process response",response.data.result.isVerified);
      if (response.data.result.isVerified) {
        const nextUrl = `/address-proof?clientId=${roomId}`;
        socket.emit("navigate", { room: roomId, url: nextUrl });
        navigate(nextUrl);
      }
      else{
        console.log("onSubmit kyc_process response false");
      }
    } catch (error) {
      console.log("somthing wrong", error);
      setErrorMessage("Invalid Captch");
    }
  };

  // Generate new CAPTCHA when modal opens
  React.useEffect(() => {
    if (show) {
      getCaptcha();
      generateCaptcha();
      setErrorMessage("");
    }
  }, [show]);

  useEffect(() => {
    if (!captchaVerified || errorMessage) {
      generateCaptcha();
    }
  }, [captchaVerified, errorMessage]);

  return (
    <Modal
  show={show}
  onHide={onHide}
  className="custom-modal"
>
  <Modal.Header closeButton style={{ backgroundColor: "#fff", border: 'none' }}>
    <Modal.Title>
      <h4 className="modal-title fs-5 fw-normal" id="exampleModal1Label">
        Please verify you’re not a spammer
        <br />
        by doing this quick activity!
      </h4>
    </Modal.Title>
  </Modal.Header>
  <Form onSubmit={handleSubmit(onSubmit)}>
    <div className="modal-body text-center">
      <div className="row">
        <div className="col-12">
          {isCptchaImage && (
            <img
              src={isCptchaImage.cptchaimg}
              alt="Captcha Image"
              id={roomId}
              // className="w-50 h-50"
            />
          )}
        </div>
        <div className="col-12 text-start ">
          <Form.Group>
            <Form.Label>
              Enter the code <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Code"
              {...register("inputText", {})}
            />
            {errors.inputText && (
              <span className="text-danger">
                {errors.inputText.message}
              </span>
            )}
          </Form.Group>
        </div>
      </div>
    </div>
    <div className="modal-footer border-0 mt-3">
      <div className="row w-100">
        <div className="col text-end d-flex justify-content-between align-items-center gap-4">
        <span className="fw-semibold captcha-icons ">
          <GrPowerReset onClick={getCaptcha}/>
          <PiWarningCircleBold  className="ms-2"/>
        </span>
          <span className="text-danger">{errorMessage}</span>
          <button className="smlbutton px-5" type="submit">
            <div className="d-flex gap-3 align-items-center">
              Verify <MdCheck />
            </div>
          </button>
        </div>
      </div>
    </div>
  </Form>
</Modal>


  );
};

export default CaptchaVerification;
